import pathOr from 'ramda/src/pathOr'
import T from 'ramda/src/T'

import moduleDescriptions from 'root/src/shared/descriptions/modules'

export default (state, { moduleId, fieldDescPath }) => pathOr(
	T,
	[moduleId, ...fieldDescPath, 'fieldAppendCondition'],
	moduleDescriptions,
)
